import { getApiUrl } from '../config';
/**
 * Recovers registration details by email address
 * Sends registration information to the user's email
 * @param email - The email address used during registration
 * @param turnstileToken - Cloudflare Turnstile verification token
 * @returns Promise with success message
 * @throws RecoverRegistrationError if the request fails
 */
export const recoverRegistration = async (email, turnstileToken) => {
    const apiUrl = getApiUrl();
    try {
        const response = await fetch(`${apiUrl}/v1/registration/recover`, {
            method: 'POST',
            credentials: 'include', // sends HttpOnly QBN_authid cookie cross-origin
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email.trim().toLowerCase(),
                turnstileToken
            }),
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw {
                message: errorData.error?.message || errorData.message || 'Failed to recover registration',
                status: response.status,
            };
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        if (error.status) {
            throw error;
        }
        throw {
            message: 'Network error. Please check your connection and try again.',
            status: 0,
        };
    }
};
